import usePageMeta from '@/hooks/usePageMeta';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SeslyMain from './components/SeslyMain';
import './sesly.css';

const SeslyPage = () => {
  usePageMeta({
    title: 'Sesly（セスリー）| SES営業・契約・請求一元管理システム | 株式会社MSK',
    ogTitle: 'Sesly（セスリー）| SES営業・契約・請求一元管理システム | 株式会社MSK',
    description:
      '案件を取ってきた後の見積・注文・月次請求・受領・入金確認までを「案件起点」で一気通貫管理。営業担当者の毎月の負担を減らすために生まれた、株式会社MSKの自社実稼働SES管理システム「Sesly」の紹介ページです。貴社業務に合わせたカスタマイズ提供に対応。',
  });

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <SeslyMain />
      <Footer />
    </div>
  );
};

export default SeslyPage;
